// src/store/auth/reducer.ts
import {
  SHOW_LOGIN_MODAL,
  HIDE_LOGIN_MODAL,
  SHOW_REGISTER_MODAL,
  HIDE_REGISTER_MODAL,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
} from "../types";

type AuthState = {
  isLoginModalVisible: boolean;
  isRegisterModalVisible: boolean;
  loading: boolean;
  error: string | null;
  user: { _id?: string; email?: string } | null;
};

const initialState: AuthState = {
  isLoginModalVisible: false,
  isRegisterModalVisible: false,
  loading: false,
  error: null,
  user: null,
};

const authReducer = (state = initialState, action: any): AuthState => {
  switch (action.type) {
    case SHOW_LOGIN_MODAL:
      return {
        ...state,
        isLoginModalVisible: true,
        isRegisterModalVisible: false,
      };
    case HIDE_LOGIN_MODAL:
      return { ...state, isLoginModalVisible: false };

    case SHOW_REGISTER_MODAL:
      return {
        ...state,
        isRegisterModalVisible: true,
        isLoginModalVisible: false,
      };
    case HIDE_REGISTER_MODAL:
      return { ...state, isRegisterModalVisible: false };

    case LOGIN_REQUEST:
      return { ...state, loading: true, error: null };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload?.user || null,
        error: null,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error || "Login failed",
      };

    case LOGOUT:
      return { ...initialState, user: null };

    default:
      return state;
  }
};

export default authReducer;
